import { Component, input } from "@angular/core";

import { DocumentDetailsWithFile } from "@app/models/form-data.interface";
import { FORM_TYPE } from "@app/models/registration-form";
import { ROUTES } from "@app/models/routes.enum";
import { SharedModule } from "@app/modules/shared/shared.module";

const zerezCompatibleValues = [
  FORM_TYPE.PV_2,
  FORM_TYPE.STORAGE_2,
  FORM_TYPE.OTHER_2,
] as const;

export type ZerezCompatibleFormType = (typeof zerezCompatibleValues)[number];

export const ZEREZ_COMPATIBLE_FORM_TYPES = new Set<string>(
  zerezCompatibleValues,
);

@Component({
  selector: "app-zerez-summary",
  imports: [SharedModule],
  templateUrl: "./zerez-summary.component.html",
  styleUrl: "./zerez-summary.component.scss",
})
export class ZerezSummaryComponent {
  public readonly stepRoute = input.required<ROUTES>();
  public readonly formType = input.required<ZerezCompatibleFormType>();
  public readonly documentDetails = input<DocumentDetailsWithFile>();
}
